module.exports = __webpack_public_path__ + "media/bootstrap-icons/spellcheck-aa4b2f8f.svg";